import type { Recipe, ShoppingCart, ActiveShoppingCart, ShoppingCategory } from '../types';
import { detectCategory } from './unitConversion';

export type KnownItem = {
    name: string;
    unit: string;
    isMeat: boolean;
    category?: string;
};

export function buildKnownItems(
    recipes: Recipe[],
    shoppingCarts: ShoppingCart[],
    activeCart: ActiveShoppingCart | null = null,
    categoryOverrides: Record<string, ShoppingCategory> = {},
): KnownItem[] {
    const seen = new Set<string>();
    const result: KnownItem[] = [];

    const addItem = (name: string, unit: string, isMeat: boolean, category?: string) => {
        const key = name.toLowerCase().trim();
        if (!key || seen.has(key)) return;
        seen.add(key);
        result.push({ name, unit, isMeat, category });
    };

    for (const cart of shoppingCarts) {
        for (const ing of cart.ingredients) {
            const key = ing.name.toLowerCase().trim();
            const category =
                categoryOverrides[key]
                || (ing.section && ing.section !== 'general' ? ing.section : undefined)
                || cart.category
                || detectCategory(ing.name, ing.isMeat);
            addItem(ing.name, ing.unit, ing.isMeat, category);
        }
    }

    for (const recipe of recipes) {
        for (const ing of recipe.ingredients) {
            const key = ing.name.toLowerCase().trim();
            const category =
                categoryOverrides[key]
                || ing.section
                || detectCategory(ing.name, ing.isMeat);
            addItem(ing.name, ing.unit, ing.isMeat, category);
        }
    }

    if (activeCart) {
        for (const item of activeCart.items) {
            const key = item.name.toLowerCase().trim();
            const category =
                categoryOverrides[key]
                || item.category
                || detectCategory(item.name, item.isMeat);
            addItem(item.name, item.unit, item.isMeat, category);
        }
    }

    return result;
}
